import React from "react";
import { COMPANY } from "../lib/constants";

export default function Legal() {
  return (
    <div data-testid="legal-page" className="py-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-3xl font-bold text-slate-900 mb-8">
          Mentions légales
        </h1>
        <div className="prose prose-slate max-w-none space-y-6 text-slate-700 text-sm leading-relaxed">
          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Éditeur du site</h2>
            <p>
              {COMPANY.full}<br />
              Téléphone : {COMPANY.phone}<br />
              Email : {COMPANY.email}<br />
              Zone d'intervention : {COMPANY.zone}
            </p>
          </section>
          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Activité</h2>
            <p>
              Hélios Solutions – Énergie & Habitat accompagne les propriétaires
              dans leurs projets de solutions énergétiques : pompe à chaleur,
              rénovation énergétique, remplacement de chauffage. Les installations
              sont réalisées par des professionnels qualifiés partenaires.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Aides et reste à charge</h2>
            <p>
              Les aides mentionnées sur ce site sont présentées à titre
              informatif. Les aides disponibles dépendent de la situation de
              chaque foyer, du logement et de la localisation. Le reste à charge
              est variable selon profil. Aucune promesse de gratuité n'est
              faite : les montants et dispositifs sont confirmés après étude
              personnalisée.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Protection des données</h2>
            <p>
              Les informations recueillies via les formulaires sont traitées
              uniquement dans le cadre de l'étude de votre projet. Vous disposez
              d'un droit d'accès, de rectification et de suppression de vos
              données. Pour toute demande, contactez {COMPANY.email}.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Propriété intellectuelle</h2>
            <p>
              L'ensemble des contenus (textes, images, logos) présents sur ce
              site est la propriété de Hélios Solutions ou utilisé avec
              autorisation. Toute reproduction sans accord préalable est
              interdite.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
